import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getFortnoxArticleUnitGroups = (token: string, backend: string) => {
    return fetch(`${getApiUrl(backend)}fortnox_article_unit_groups`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getFortnoxArticleUnitGroups